export const FORM_ENCODED = 'application/x-www-form-urlencoded';
export const JSON_ENCODED = 'application/json';
